import { type ComponentType } from 'react';
import { GitCiCardSlot } from './components/git-ci-card-slot';
import { GitCrSummarySlot } from './components/git-cr-summary-slot';
import { GitReleaseChipsSlot } from './components/git-release-chips';
import { GitWebhookCardSlot } from './components/git-webhook-status';
import { GitTaskCoverageSlot } from './components/git-task-coverage-slot';
import {
  type GitChangeRequestDrawerSlotProps,
  type GitChangeRequestRowSlotProps,
  type GitDevelopmentSlotProps,
  type GitRepositoryCardSlotProps,
} from './types';
import { GitWriteActions } from './components/git-write-actions';

/**
 * Chỗ cắm của tab Git — APM-GIT-e.
 *
 * Bốn mảng **rỗng có chủ ý**. Mỗi task sau của `APM-GIT-*` có dữ liệu mới để
 * hiện trên một thứ đã dựng (chấm CI của nhánh chính trên thẻ kho, chip "có
 * trong v1.4.0" trên task, tóm tắt AI trong ngăn MR) thì viết **một component**
 * nhận đúng prop của chỗ cắm và thêm **một dòng** vào mảng tương ứng — không sửa
 * thẻ kho, hàng MR, ngăn bên hay khối "Phát triển".
 *
 * Mảng rỗng ⇒ không render gì: không có khung giữ chỗ nào cho thứ chưa có dữ liệu.
 *
 * Component cắm vào tự `useQuery` thì nhận `asOf` từ prop (luật #7).
 *
 * | Mảng | Hiện ở đâu | Dự kiến |
 * | --- | --- | --- |
 * | `GIT_REPOSITORY_CARD_SLOTS` | cuối thẻ kho (Tổng quan), trên hàng nút | webhook `-g` · CI nhánh chính `-i` |
 * | `GIT_CHANGE_REQUEST_ROW_SLOTS` | cạnh trạng thái review của một MR (bảng, thẻ di động, khối "Phát triển") | bản phát hành `-i` |
 * | `GIT_CHANGE_REQUEST_DRAWER_SLOTS` | ngăn bên của MR, giữa bốn pha và danh sách commit | pipeline `-i` · tóm tắt AI `-m` |
 * | `GIT_DEVELOPMENT_SLOTS` | khối "Phát triển", dưới hàng nút | Tạo nhánh / Tạo MR `-k` · chip bản phát hành `-i` · đối chiếu tiêu chí `-n` |
 */
export const GIT_REPOSITORY_CARD_SLOTS: readonly ComponentType<GitRepositoryCardSlotProps>[] = [
  // APM-GIT-i: CI nhánh mặc định (§8.1).
  GitCiCardSlot,
  GitWebhookCardSlot,
];

export const GIT_CHANGE_REQUEST_ROW_SLOTS: readonly ComponentType<GitChangeRequestRowSlotProps>[] =
  [];

export const GIT_CHANGE_REQUEST_DRAWER_SLOTS: readonly ComponentType<GitChangeRequestDrawerSlotProps>[] =
  [
    // APM-GIT-m: tóm tắt MR bằng AI (§8.5).
    GitCrSummarySlot,
  ];

export const GIT_DEVELOPMENT_SLOTS: readonly ComponentType<GitDevelopmentSlotProps>[] = [
  // APM-GIT-k: Tạo nhánh / Tạo merge request.
  GitWriteActions,
  // APM-GIT-i: "có trong v…" / "đã lên production dd/MM/yyyy" (§8.2).
  GitReleaseChipsSlot,
  // APM-GIT-n: đối chiếu tiêu chí của việc với MR đã gắn (§8.5) — bảng làm tay + gợi ý AI.
  GitTaskCoverageSlot,
];
